<div id="payment-request-button" [class]="customClass">
  <!-- A Stripe Element will be inserted here. -->
</div>
